import { RootState } from 'src/store/store';

import { useSelector } from 'react-redux';

import WrapperOverview from '@components/styled-UI/WrapperOverview';

import { getLabelFallback } from '@utils/utils';

const EmptyOnlineOrdersHistory = (): JSX.Element => {
    const { isMobile, config } = useSelector((state: RootState) => state.common);

    const redirectToExternalPage = (link: string) => {
        window.open(link, '_parent');
    };

    return (
        <>
            <h2 className="online-orders-history-title primary-title">
                {getLabelFallback('MYPURCHASES_ONLINE_ORDERS_PAGE_LABEL')}
            </h2>
            <WrapperOverview customStyle="online-orders-overview">
                <div className="overview--online-orders-overview-title">
                    {getLabelFallback('MYPURCHASES_ONLINE_ORDERS_EMPTY_MESSAGE_TITLE')}
                </div>
                {!isMobile ? 
                    (
                        <div className="primary-message small overview--online-orders-overview-message">
                            <span>
                                {getLabelFallback('MYPURCHASES_ONLINE_ORDERS_EMPTY_MESSAGE_FIRST_PART')}
                            </span>
                            <span>
                                {getLabelFallback('MYPURCHASES_ONLINE_ORDERS_EMPTY_MESSAGE_SECOND_PART')}
                            </span>
                        </div>
                    )
                    : (
                        <div className="primary-message small overview--online-orders-overview-message">
                            <span>
                                {getLabelFallback('DASHBOARD_MY_ORDERS_EMPTY_CARD_TEXT')}
                            </span>
                        </div>
                    )
                }
                <div className="overview--online-orders-overview-buttons">
                    <button
                        className="primary-button button-size-medium"
                        data-element-id="OrderHistory_ShopEyewear"
                        onClick={() =>
                            redirectToExternalPage(
                                config.callFromComponentToTO.myPurchases.onlineOrders.shopEyewear
                            )
                        }
                    >
                        {getLabelFallback('MYPURCHASES_ONLINE_ORDERS_SHOP_EYEWEAR_CTA_LABEL')}
                    </button>
                    {config.countryName.toLowerCase() !== 'ca' && (
                        <button
                            className="primary-button button-size-medium"
                            data-element-id="OrderHistory_ShopContactLenses"
                            onClick={() =>
                                redirectToExternalPage(
                                    config.callFromComponentToTO.myPurchases.onlineOrders
                                        .shopContactLenses
                                )
                            }
                        >
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_SHOP_CONTACT_LENSES_CTA_LABEL'
                            )}
                        </button>
                    )}
                </div>
            </WrapperOverview>
        </>
    );
};
export default EmptyOnlineOrdersHistory;
